// const basicUrl="http://192.168.10.103:8001/basic"                                          //开发环境
// const cloudUrl="http://192.168.10.103:8005/cloud"                                          //开发环境

// const basicUrl = "http://test.api2.ctpark.cn/basic" //线上测试环境
// const cloudUrl = "http://test.api2.ctpark.cn/cloud" //线上测试环境

const basicUrl = "http://api2.ctpark.cn/basic" //正式环境
const cloudUrl = "http://api2.ctpark.cn/cloud" //正式环境


const carUrl = "https://ac.yunzongnet.com/api/getAc/555418379687587840" //车牌页banner
const payDetails = "https://ac.yunzongnet.com/api/getAc/555418304383078400" //收银台（支付详细）页banner
const receipt = "https://ac.yunzongnet.com/api/getAc/555417964602486784" //商家小票
const payUrl = "https://ac.yunzongnet.com/api/ac/555417964531183616" //支付完成后直跳

const newYearActivityImage = "../static/img/activity-0601.png" //新年展示活动图
const newYearImage = "../static/img/activity-0601.png" //新年展示活动图
const newYearInfoUrl = "https://mp.weixin.qq.com/s/flE9SUuSotssK7VchcsrSA" //新年展示活动规则地址
const newYearUrl = "https://unionhy.58.com/te/view/cqctyx?source=qudao180&tf_city=37&tf_media=cqctyx?source=qudao180&tf_city=37&tf_media=changting" //新年活动链接地址
const money=180;
// 基础服务接口
const loginUrl = basicUrl + "/wepub/login/doLogin" //登录
const sendMes = basicUrl + "/wepub/login/sendMes" //发送验证吗
const getUserBalance = basicUrl + "/wepub/login/queryUserBalance" //获取用户余额
const queryBindCar = basicUrl + "/wepub/login/queryBindCar" //获取绑定车牌
//优惠券
const useableCouponUrl = basicUrl + "/wepub/coupon/useableCoupon" //查询可使用优惠券
const myCouponUrl = basicUrl + "/wepub/coupon/userCoupon" //查询我的优惠券
const ueseCouponUrl = cloudUrl + "/rb/emsCnpl/couponLogic" //使用优惠券

const clearCouponCache = cloudUrl + "/wepub/order/clearCouponCache" //查询订单
const queryWechatOrder = cloudUrl + "/wepub/order/queryOrderbyCarNum" //查询订单
//................




const getOpenidUrl = cloudUrl + "/wepub/order/getOpenId" //获取openid
const getpayWayList = cloudUrl + "/wepub/order/queryWechatSupportPayWay" //获取支持的支付方式
// const getpayWayList = cloudUrl + "/wepub/order/querySupportPayWay" //获取支持的支付方式
const wxPubPay = cloudUrl + "/wepub/order/wxPubPay" //微信公众号支付入口
const queryAdvert = cloudUrl + "/wepub/adver/queryAdvertisingBySite" //获取广告信息
const advertUpdate = cloudUrl + "/wepub/adver/advertUpdate" //更新广告信息
const myCar = basicUrl + "/wepub/user/myCar" //获取绑定车辆信息
const bindCar = basicUrl + "/wepub/user/bindCar" //绑定车辆
const relieveBind = basicUrl + "/wepub/user/relieveBind" //解除绑定
const carInfoUpload = cloudUrl + "/cloud/carExplain/carInfoUpload" //提交车牌申述
const getWxSignature = cloudUrl + "/cloud/carExplain/getWxSignature" //获取微信签名
const myWallet = basicUrl + "/wepub/user/myWallet" //获取账户余额
const walletDetail = basicUrl + "/wepub/user/walletDetail" //获取账户余额流水
const walletDetailInfo = basicUrl + "/wepub/user/walletDetailInfo" //获取账户余额流水详情
const recharge = basicUrl + "/wepub/user/recharge" //获取账户余额
const parkingRecord = basicUrl + "/wepub/user/parkingRecord" //获取停车历史记录列表
const noPayRecord = basicUrl + "/wepub/user/noPayRecord" //获取停车待缴费记录列表
const getOrderInfo = basicUrl + "/wepub/user/getOrderInfo" //获取停车订单信息
const noPayRecordNew = basicUrl + "/wepub/user/noPayRecordNew" //便捷补缴通道*

//版本号
const versionname = 'V2.8.24'
export default {
  loginUrl,
  sendMes,
  useableCouponUrl,
  myCouponUrl,
  ueseCouponUrl,
  clearCouponCache,
  queryWechatOrder,
  getOpenidUrl,
  getpayWayList,
  getUserBalance,
  queryBindCar,
  wxPubPay,
  queryAdvert,
  advertUpdate,
  versionname, //....................
  myCar,
  bindCar,
  relieveBind,
  myWallet,
  walletDetail,
  walletDetailInfo,
  carInfoUpload,
  recharge,
  parkingRecord,
  noPayRecord,
  getOrderInfo,
  getWxSignature,
  noPayRecordNew,
  carUrl,
  payDetails,
  receipt,
  payUrl,
  newYearActivityImage,
  newYearImage,
  newYearUrl,
  money,
  newYearInfoUrl
}



// WEBPACK FOOTER //
// ./src/http/api.js